import {Indexer} from 'rlink-cms/indexing';
import formattedImgPath from 'rlink-repos/formattedImgPath';

export default class ImageItemIndexer extends Indexer {
  get sortKey () {
    return ['priority'];
  }

  itemData (content) {
    return content.data.set('imagePath', content.imagePath).set('mainImageFormats', content.mainImageFormats);
  }

  get linkedContentPaths () {
    let pathList = new Set();

    for (let item of this.items) {
      let imagePath = item.get('mainImageFormats');
      for (let format of (imagePath.get('formats') || [{contentType: 'image/jpeg', fileExt: 'jpg'}])) {
        for ( let width of (imagePath.get('widths') || []) ) {
          pathList.add(formattedImgPath(imagePath.get('src'), {width}, format.get('fileExt')));
        }
        for (let height of (imagePath.get('heights') || [])) {
          pathList.add(formattedImgPath(imagePath.get('src'), {height}, format.get('fileExt')));
        }
      }
    }
    return Array.from(pathList);
  }
}

ImageItemIndexer.contentClassName = 'ImageItem';



// WEBPACK FOOTER //
// ./lib/rlink-media/indexers/ImageItemIndexer.js